module.exports = __webpack_public_path__ + "fonts/思源宋体CN-Regular.85b46b6b.otf";